// eslint-disable-next-line max-classes-per-file
export class ResponseTotalItemFavouriteByCityId {
  displayName: string = "";

  type: string = "";

  total: number = 0;

  icon: string;

  constructor(data: any) {
    this.displayName = data.displayName || "";
    this.type = data.type || "";
    this.total = data.total || 0;
    this.icon = data.icon || "";
  }
}

export class ResponseDataFavouriteByCityId {
  city_id: number = 0;

  city_name: string = "";

  city_name_tran: string = "";

  isGreenCertificate?: boolean;

  total_item: ResponseTotalItemFavouriteByCityId[] = [];

  city_image: string = "";

  constructor(value: any) {
    this.isGreenCertificate = value?.isGreenCertificate || false;
    this.city_id = value.city_id || 0;
    this.city_name = value.city_name || "";
    this.city_name_tran = value.city_name_tran || "";
    this.city_image =
      value.city_image ||
      "https://d31jk6ljx7wihh.cloudfront.net/images/activity.webp";
    this.total_item = (value.total_item || []).map(
      (totalItem: any) => new ResponseTotalItemFavouriteByCityId(totalItem),
    );
  }
}

export class ResponseFavouriteByCityId {
  data: ResponseDataFavouriteByCityId[] = [];

  total_city: number;

  constructor(value: any) {
    this.data = (value.data || []).map(
      (data: any) => new ResponseDataFavouriteByCityId(data),
    );
    this.total_city = value.total_city || "";
  }
}
